// extracted by mini-css-extract-plugin
export default {"wrapper":"Notifications_wrapper__2Nb3R"};